export default "__VITE_ASSET__mfSZYaew__"